module.exports = __webpack_public_path__ + "static/media/paynl_logo.daacf760.png";